export default __webpack_public_path__ + "static/media/recommendations-empty.4d8d0f8a.svg";